import request from '@/http/request'

// 资金流水API基础路径
export const API_URL_FUND_FLOW_LIST = '/api/mchTransactionRecord/list'

// 获取资金流水列表
export function getFundFlowList (params) {
  return request.request({
    url: API_URL_FUND_FLOW_LIST,
    method: 'POST',
    data: params
  })
}

// 导出资金流水
export function exportFundFlow (params) {
  return request.request({
    url: `${API_URL_FUND_FLOW_LIST}/export`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 获取资金流水详情
export function getFundFlowDetail (id) {
  return request.request({
    url: `${API_URL_FUND_FLOW_LIST}/${id}`,
    method: 'get'
  })
}

// 变更类型枚举
export const CHANGE_TYPE_ENUM = {
  RECHARGE: 'RECHARGE', // 充值
  WITHDRAW: 'WITHDRAW', // 提现
  PAYMENT: 'PAYMENT', // 支付
  REFUND: 'REFUND', // 退款
  TRANSFER_IN: 'TRANSFER_IN', // 转入
  TRANSFER_OUT: 'TRANSFER_OUT', // 转出
  FEE: 'FEE', // 手续费
  COMMISSION: 'COMMISSION', // 佣金
  DEBIT: 'DEBIT', // 扣款
  CREDIT: 'CREDIT', // 增款
  SETTLE: 'SETTLE' // 代收结算
}

// 变更类型选项
export const CHANGE_TYPE_OPTIONS = [
  { value: '', label: '全部' },
  { value: 1, label: '充值' },
  { value: 2, label: '提现' },
  { value: 3, label: '代收' },
  { value: 4, label: '代付' },
  { value: 5, label: '退款' },
  { value: 6, label: '扣款' },
  { value: 7, label: '增款' },
  { value: 11, label: '代收结算' }
  // { value: '6', label: '手续费' },
  // { value: 'COMMISSION', label: '佣金' }
]

// 获取变更类型文本
export function getChangeTypeText (type) {
  console.log('>>', type, CHANGE_TYPE_OPTIONS)
  const option = CHANGE_TYPE_OPTIONS.find(item => Number(item.value) === Number(type))
  console.log('>>', option)
  console.log('>>', option ? option.label : type)
  return option ? option.label : type
}

// 获取变更类型颜色
export function getChangeTypeColor (type) {
  const colorMap = {
    1: 'green',
    2: 'orange',
    3: 'green',
    4: 'blue',
    5: 'purple',
    6: '#7d2223',
    7: '#214b0c',
    11: '#203f12'
    // TRANSFER_IN: 'cyan',
    // TRANSFER_OUT: 'red',
    // FEE: 'volcano',
    // COMMISSION: 'gold'
  }
  return colorMap[type] || 'default'
}
